document.addEventListener("DOMContentLoaded", function () {

  // ✅ Load liked videos from localStorage
  const likedVideos = JSON.parse(localStorage.getItem("likedVideos") || "[]");

  // ✅ Like Button Click
  document.querySelectorAll(".video-count-api .videocardapi .like-btn").forEach(function (btn) {
    btn.addEventListener("click", async function () {

      const parentCard = btn.closest(".videocardapi");
      const video = parentCard?.querySelector(".videocardpopupapi video");
      const website = document.body.getAttribute("data-website");
      const title = parentCard?.getAttribute("data-producttitle");
      const url = video?.querySelector("source")?.getAttribute("src");
      const likeCountSpan = btn.querySelector(".like-count");

      if (!url || !website || !title) {
        console.error("Missing data → cannot process like.");
        return;
      }

      // ✅ Already liked check
      if (likedVideos.includes(url)) {
        console.log("⚠️ Already liked this video:", url);
        btn.classList.add("disabled");
        return;
      }

      // Prevent multiple quick clicks
      if (btn.classList.contains("disabled")) return;
      btn.classList.add("disabled");

      const formData = new FormData();
      formData.append("website", website);
      formData.append("title", title);
      formData.append("url", url);

      try {
        const response = await fetch(
          "https://digital.agarolifestyle.com/luvlap_api/Like-App/video-like.php",
          { method: "POST", body: formData }
        );

        const result = await response.json();
        console.log("✅ Like update:", result);

        if (result.status === "success") {
              let count = parseInt(result.total_likes) || 0;

              function formatLikes(n) {
                  if (n >= 1_000_000) {
                      return (n / 1_000_000).toFixed(1).replace(".0", "") + "M";
                  }
                  if (n >= 1_000) {
                      return (n / 1_000).toFixed(1).replace(".0", "") + "k";
                  }
                  return n.toString();
              }

              const formattedCount = formatLikes(count);

              likeCountSpan.textContent = count > 0 ? `(${formattedCount})` : "";
              likeCountSpan.style.display = count > 0 ? "inline-block" : "none";



          // ✅ Save liked video to localStorage
          likedVideos.push(url);
          localStorage.setItem("likedVideos", JSON.stringify(likedVideos));
        } else {
          console.error("❌ Server Error:", result.message);
        }

      } catch (error) {
        console.error("❌ Like Error:", error);
      }
    });
  });




function formatLikes(num) {
  if (num >= 1000000) return (num / 1000000).toFixed(1).replace(/\.0$/, '') + "M";
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + "k";
  return num.toString();
}

 // ✅ Initial Like Count Fetch + Disable Already Liked Buttons
async function initAllCards() {
  const videoCards = document.querySelectorAll(".videocardapi");
  const website = document.body.getAttribute("data-website");
  console.log("🎥 Total Video Cards:", videoCards.length);

  videoCards.forEach(async function (card) {
    const videoEl = card.querySelector("video");
    const sourceEl = videoEl ? videoEl.querySelector("source") : null;
    const videoURL = sourceEl ? sourceEl.getAttribute("src") : null;
    const likeCountSpan = card.querySelector(".like-count");

    if (!videoURL || !likeCountSpan || !website) {
      console.warn("⚠️ Missing required data → Skipped");
      return;
    }

    const formData = new FormData();
    formData.append("url", videoURL);
    formData.append("website", website);

    try {
      const response = await fetch(
        "https://digital.agarolifestyle.com/luvlap_api/Like-App/get-video-like.php",
        { method: "POST", body: formData }
      );

      const result = await response.json();
      const count = parseInt(result.total_likes) || 0;

      likeCountSpan.innerText = count > 0 ? `(${formatLikes(count)})` : "";
      likeCountSpan.style.display = count > 0 ? "inline-block" : "none";

      // ✅ Disable button if already liked
      if (likedVideos.includes(videoURL)) {
        const btn = card.querySelector(".like-btn");
        if (btn) btn.classList.add("disabled");
      }

    } catch (error) {
      console.error("❌ Like count fetch failed:", error);
      likeCountSpan.innerText = "";
      likeCountSpan.style.display = "none";
    }
  });
}

  initAllCards();
});
